<template>
    <ul v-if="allergies?.length" class="flex flex-wrap gap-2 sm:gap-3">
        <li
            v-for="allergyItem in allergies"
            :key="id + allergyItem"
        >
            <template v-if="allergyItem">
                <ToolTip
                    default-slot-classes="flex h-4 w-4 cursor-pointer items-center justify-center rounded-full border border-gray-200 p-4 text-sm text-gray-600 transition-opacity hover:border-gray-600 sm:h-6 sm:w-6 sm:text-lg relative"
                    :aria-id="`allergies-${id}-${allergyItem}`"
                >
                    <Icon :icon="getAllergiesIcon(allergyItem)" :auto-align="false" />
                    <span
                        v-if="allergyItem.includes('TRACES')"
                        class="absolute bottom-0 right-0 size-6 translate-x-1/4 translate-y-[14%] text-center text-xs font-bold leading-6 text-black "
                    >
                        {{ "?" }}
                    </span>
                    <template #popper>
                        <div v-html="$te(`shopPage.allergies.${allergyNormalized(allergyItem)}`) ? $t(`shopPage.allergies.${allergyNormalized(allergyItem)}`) : `Missing description for allergy ${allergyNormalized(allergyItem)}`" />
                        <div v-if="allergyItem.includes('TRACES')">
                            <br />{{ $t('shopPage.allergies.traces') }}
                        </div>
                    </template>
                </ToolTip>
            </template>
        </li>
    </ul>
</template>

<script setup lang="ts">
    import type { AllergiesProps } from '~/types/local-types'
    import IconAlcohol from '@/assets/icons/allergy-alcohol.svg'
    import IconAzo from '@/assets/icons/allergy-azo.svg'
    import IconBio from '@/assets/icons/allergy-bio.svg'
    import IconCelery from '@/assets/icons/allergy-celery.svg'
    import IconCoconut from '@/assets/icons/allergy-coconut.svg'
    import IconCrab from '@/assets/icons/allergy-crab.svg'
    import IconEggs from '@/assets/icons/allergy-eggs.svg'
    import IconFish from '@/assets/icons/allergy-fish.svg'
    import IconGluten from '@/assets/icons/allergy-gluten.svg'
    import IconHalal from '@/assets/icons/allergy-halal.svg'
    import IconLupine from '@/assets/icons/allergy-lupine.svg'
    import IconMilk from '@/assets/icons/allergy-milk.svg'
    import IconMolluscs from '@/assets/icons/allergy-molluscs.svg'
    import IconMustard from '@/assets/icons/allergy-mustard.svg'
    import IconNoGluten from '@/assets/icons/allergy-no_gluten.svg'
    import IconNoLactose from '@/assets/icons/allergy-no_lactose.svg'
    import IconNut from '@/assets/icons/allergy-nut.svg'
    import IconPeanuts from '@/assets/icons/allergy-peanuts.svg'
    import IconPig from '@/assets/icons/allergy-pig.svg'
    import IconSesame from '@/assets/icons/allergy-sesame.svg'
    import IconShellfish from '@/assets/icons/allergy-shellfish.svg'
    import IconSo2 from '@/assets/icons/allergy-so2.svg'
    import IconSoy from '@/assets/icons/allergy-soy.svg'
    import IconVegan from '@/assets/icons/allergy-vegan.svg'
    import IconVeggan from '@/assets/icons/allergy-veggan.svg'
    import IconWheat from '@/assets/icons/allergy-wheat.svg'
    import Icon from '~/components/Icon.vue'
    import ToolTip from '~/components/ToolTip.vue'

    defineProps<AllergiesProps>()
    function allergyNormalized (allergy: string) {
        return allergy.toLowerCase().replace('_traces', '')
    }
    const getAllergiesIcon = computed(() => {
        return allergyItem => {
            switch (allergyNormalized(allergyItem)) {
            case 'wheat':
                return IconWheat
            case 'gluten':
                return IconGluten
            case 'shellfish':
                return IconShellfish
            case 'eggs':
                return IconEggs
            case 'fish':
                return IconFish
            case 'peanuts':
                return IconPeanuts
            case 'soy':
                return IconSoy
            case 'milk':
                return IconMilk
            case 'nut':
                return IconNut
            case 'celery':
                return IconCelery
            case 'mustard':
                return IconMustard
            case 'sesame':
                return IconSesame
            case 'so2':
                return IconSo2
            case 'lupine':
                return IconLupine
            case 'molluscs':
                return IconMolluscs
            case 'vegetarian':
                return IconVegan
            case 'vegan':
                return IconVegan
            case 'veggan':
                return IconVeggan
            case 'no_gluten':
                return IconNoGluten
            case 'halal':
                return IconHalal
            case 'pig':
                return IconPig
            case 'bio':
                return IconBio
            case 'coconut':
                return IconCoconut
            case 'no_lactose':
                return IconNoLactose
            case 'alcohol':
                return IconAlcohol
            case 'azo':
                return IconAzo
            case 'crab':
                return IconCrab
            default:
                return false
            }
        }
    })
</script>
